<template>
  <div :class="[{ 'direction-right': isRight, 'color-dark': isDark}, 'voice']">
    <IconBase class="voice_icon" :width="20"><Voice/></IconBase>
    <div class="title">
      先輩<br>社員の声
    </div>
    <div class="content">
      <p>
        {{message}}
      </p>
    </div>
  </div>
</template>

<script>
import IconBase from "@/components/IconBase.vue";
import Voice from "@/components/icons/Voice.vue";
export default {
  name: 'VoiceAboutOffice',
  components: {
    IconBase,
    Voice
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped lang="scss">
.voice {
  width: 100%;
  position: relative;
  font-size: 15px;
  font-weight: bold;
  color: #3fae00;
  margin-top: 100px;
  @media print,screen and (min-width: 768px) {
    max-width: 480px;
  }
  &.color-dark {
    color: #00797f;
    .title {
      background-color: #00797f;
    }
    .content {
      border: 2px solid #00797f;
      &:after {
        background-color: #00797f;
      }
    }
  }
  &.direction-right {
    margin-left: unset;
    @media print,screen and (min-width: 768px) {
      margin-right: 3em;
    }
    .voice_icon {
      right: 0px;
      left: unset;
      transform: rotate(65deg);
    }
    .title {
      left: unset;
      top: -3em;
      right: 0;
    }
    .content {
      margin-left: 0;
      &:before {
        right: 30%;
        left: unset;
      }
      &:after {
        right: 30%;
        left: unset;
        transform: rotate(-45deg) translate(-3px,-3px);
      }
    }
  }
}
.voice_icon {
  top: -60px;
  position: absolute;
}
.title {
  border-radius: 100%;
  position: absolute;
  background-color: #3fae00;
  color: #fff;
  font-size: 16px;
  text-align: center;
  width: 6em;
  height: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5em;
  top: -3em;
  z-index: 1;
}
.content {
  width: calc(100% - 3em);
  border: 2px solid #3fae00;
  border-radius: 20px;
  position: relative;
  margin-left: 3em;
  @media print,screen and (min-width: 768px) {
    max-width: 430px;
  }
  p {
    padding: 30px 50px;
    margin: 0;
    text-align: justify;
  }
  &:before {
    content: "";
    width: 30px;
    height: 2px;
    background-color: #fff;
    top: -2px;
    left: 30%;
    position: absolute;
  }
  &:after {
    content: "";
    width: 30px;
    height: 2px;
    background-color: #3fae00;
    top: -12px;
    left: 30%;
    position: absolute;
    transform: rotate(45deg) translate(3px,-3px);
  }
}
</style>